// extracted by mini-css-extract-plugin
module.exports = {"message":"ExternalBookingErrorDialog_message___ff4X"};